import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster, toast } from "sonner";
import { 
  Phone, Mail, MapPin, Calendar, Users, Star, Menu, X, 
  ChevronDown, ArrowRight, Sparkles, Clock, Shield, Award,
  PartyPopper, Heart, GraduationCap, Wine, Gift, Snowflake,
  MessageCircle, Instagram, Facebook
} from "lucide-react";
import { Button } from "./components/ui/button";
import { Input } from "./components/ui/input";
import { Label } from "./components/ui/label";
import { Textarea } from "./components/ui/textarea";
import { Calendar as CalendarComponent } from "./components/ui/calendar";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./components/ui/dialog";
import { Card, CardContent } from "./components/ui/card";
import { format } from "date-fns";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Logo URL
const LOGO_URL = "https://customer-assets.emergentagent.com/job_hookah-party-pro/artifacts/j75gslu1_IMG_0184.jpeg";

// WhatsApp Number
const WHATSAPP_NUMBER = "16786977861";

// Image Assets
const IMAGES = {
  hero: "https://images.unsplash.com/photo-1517983079452-bbaa6a081a6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBwYXJ0eSUyMGNlbGVicmF0aW9uJTIwbmlnaHRjbHVifGVufDB8fHx8MTc3Mzc2MjAzMXww&ixlib=rb-4.1.0&q=85",
  services: {
    birthday: "https://images.unsplash.com/photo-1763828028975-afa6ae9d04de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwYmlydGhkYXklMjBwYXJ0eSUyMGNlbGVicmF0aW9ufGVufDB8fHx8MTc3Mzc2MjAzM3ww&ixlib=rb-4.1.0&q=85",
    anniversary: "https://images.unsplash.com/photo-1695128963387-c9288376d9c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBwYXJ0eSUyMGNlbGVicmF0aW9uJTIwbmlnaHRjbHVifGVufDB8fHx8MTc3Mzc2MjAzMXww&ixlib=rb-4.1.0&q=85",
    graduation: "https://images.unsplash.com/photo-1769814444191-5132779e7002?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwYmlydGhkYXklMjBwYXJ0eSUyMGNlbGVicmF0aW9ufGVufDB8fHx8MTc3Mzc2MjAzM3ww&ixlib=rb-4.1.0&q=85",
    bachelorette: "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800",
    private: "https://images.unsplash.com/photo-1760865461468-d80681140a63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwYXJ0eSUyMGNlbGVicmF0aW9uJTIwbmlnaHRjbHVifGVufDB8fHx8MTc3Mzc2MjAzMXww&ixlib=rb-4.1.0&q=85",
    holiday: "https://images.unsplash.com/photo-1755493872657-258e83e22279?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxiYWNoZWxvcmV0dGUlMjBwYXJ0eSUyMGNlbGVicmF0aW9ufGVufDB8fHx8MTc3Mzc2MjAzNHww&ixlib=rb-4.1.0&q=85"
  },
  gallery: [
    "https://images.unsplash.com/photo-1517983079452-bbaa6a081a6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBwYXJ0eSUyMGNlbGVicmF0aW9uJTIwbmlnaHRjbHVifGVufDB8fHx8MTc3Mzc2MjAzMXww&ixlib=rb-4.1.0&q=85",
    "https://customer-assets.emergentagent.com/job_hookah-party-pro/artifacts/hb0r4ews_IMG_0178.jpeg",
    "https://images.unsplash.com/photo-1763828028975-afa6ae9d04de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwYmlydGhkYXklMjBwYXJ0eSUyMGNlbGVicmF0aW9ufGVufDB8fHx8MTc3Mzc2MjAzM3ww&ixlib=rb-4.1.0&q=85",
    "https://customer-assets.emergentagent.com/job_hookah-party-pro/artifacts/1arw30xi_IMG_0181.jpeg",
    "https://customer-assets.emergentagent.com/job_hookah-party-pro/artifacts/rd4lnks8_IMG_0182.jpeg",
    "https://images.unsplash.com/photo-1760865461468-d80681140a63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwYXJ0eSUyMGNlbGVicmF0aW9uJTIwbmlnaHRjbHVifGVufDB8fHx8MTc3Mzc2MjAzMXww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1695128963387-c9288376d9c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBwYXJ0eSUyMGNlbGVicmF0aW9uJTIwbmlnaHRjbHVifGVufDB8fHx8MTc3Mzc2MjAzMXww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1769814444191-5132779e7002?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwYmlydGhkYXklMjBwYXJ0eSUyMGNlbGVicmF0aW9ufGVufDB8fHx8MTc3Mzc2MjAzM3ww&ixlib=rb-4.1.0&q=85"
  ],
  gaslight: "https://customer-assets.emergentagent.com/job_hookah-party-pro/artifacts/1arw30xi_IMG_0181.jpeg",
  gaslightGallery: [
    "https://customer-assets.emergentagent.com/job_hookah-party-pro/artifacts/1arw30xi_IMG_0181.jpeg",
    "https://customer-assets.emergentagent.com/job_hookah-party-pro/artifacts/rd4lnks8_IMG_0182.jpeg",
    "https://customer-assets.emergentagent.com/job_hookah-party-pro/artifacts/hb0r4ews_IMG_0178.jpeg"
  ]
};

// Helper function to send WhatsApp notification
const sendWhatsAppNotification = (bookingData) => {
  const message = `New Booking Request!\n\nName: ${bookingData.name}\nEmail: ${bookingData.email}\nPhone: ${bookingData.phone}\nEvent: ${bookingData.event_type}\nDate: ${bookingData.event_date}\nGuests: ${bookingData.guest_count}\nVenue: ${bookingData.venue_type}${bookingData.location ? `\nLocation: ${bookingData.location}` : ''}${bookingData.message ? `\nMessage: ${bookingData.message}` : ''}`;
  
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, '_blank');
};

// Services Data
const SERVICES = [
  { id: "birthday", title: "Birthday Parties", icon: PartyPopper, image: IMAGES.services.birthday, description: "Make your special day unforgettable with our premium hookah service" },
  { id: "anniversary", title: "Anniversaries", icon: Heart, image: IMAGES.services.anniversary, description: "Celebrate your love story with an elegant hookah experience" },
  { id: "graduation", title: "Graduations", icon: GraduationCap, image: IMAGES.services.graduation, description: "Honor achievements with a sophisticated celebration" },
  { id: "bachelorette", title: "Bachelor/ette Parties", icon: Wine, image: IMAGES.services.bachelorette, description: "Last fling before the ring with style and class" },
  { id: "private", title: "Private Events", icon: Gift, image: IMAGES.services.private, description: "Exclusive service for your intimate gatherings" },
  { id: "holiday", title: "Holiday Celebrations", icon: Snowflake, image: IMAGES.services.holiday, description: "Festive hookah experiences for every season" }
];

// Navigation Component
const Navbar = ({ scrolled }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-black/90 backdrop-blur-lg py-4' : 'bg-transparent py-6'}`}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
          {/* Logo */}
          <button onClick={() => scrollToSection('hero')} className="flex items-center gap-3" data-testid="nav-logo">
            <img src={LOGO_URL} alt="EMBT Logo" className="w-12 h-12 rounded-full object-cover border-2 border-[#D4AF37]" />
            <div className="hidden sm:block">
              <span className="font-heading text-xl text-white">EMBT</span>
              <span className="block text-xs text-[#D4AF37] uppercase tracking-widest">Hookah Service</span>
            </div>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('services')} className="nav-link" data-testid="nav-services">Services</button>
            <button onClick={() => scrollToSection('gallery')} className="nav-link" data-testid="nav-gallery">Gallery</button>
            <button onClick={() => scrollToSection('gaslight')} className="nav-link" data-testid="nav-gaslight">Venue</button>
            <button onClick={() => scrollToSection('testimonials')} className="nav-link" data-testid="nav-testimonials">Reviews</button>
            <button onClick={() => scrollToSection('contact')} className="nav-link" data-testid="nav-contact">Contact</button>
          </div>

          {/* Book Now Button */}
          <div className="hidden md:block">
            <Button onClick={() => scrollToSection('booking')} className="btn-primary" data-testid="nav-book-now">
              Book Now
            </Button>
          </div>

          {/* Mobile Menu Toggle */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)} 
            className="md:hidden text-white"
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu" data-testid="mobile-menu">
          <button onClick={() => scrollToSection('services')} className="mobile-menu-link">Services</button>
          <button onClick={() => scrollToSection('gallery')} className="mobile-menu-link">Gallery</button>
          <button onClick={() => scrollToSection('gaslight')} className="mobile-menu-link">Venue</button>
          <button onClick={() => scrollToSection('testimonials')} className="mobile-menu-link">Reviews</button>
          <button onClick={() => scrollToSection('contact')} className="mobile-menu-link">Contact</button>
          <Button onClick={() => scrollToSection('booking')} className="btn-primary mt-4" data-testid="mobile-book-now">
            Book Now
          </Button>
        </div>
      )}
    </>
  );
};

// Hero Section
const HeroSection = () => {
  const scrollToBooking = () => {
    document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero-section" data-testid="hero-section">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src={IMAGES.hero} 
          alt="Luxury party atmosphere" 
          className="w-full h-full object-cover opacity-40"
        />
        <div className="hero-overlay"></div>
      </div>

      {/* Glow Effect */}
      <div className="hero-glow top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></div>

      {/* Content */}
      <div className="hero-content">
        <div className="animate-fade-in-up opacity-0" style={{ animationDelay: '0.2s' }}>
          <span className="font-accent text-[#D4AF37] text-sm md:text-base uppercase tracking-[0.3em] mb-6 block">
            Atlanta's Premier Hookah Catering
          </span>
        </div>
        
        <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 animate-fade-in-up opacity-0" style={{ animationDelay: '0.4s' }}>
          Elevate Your <span className="text-gold-gradient">Celebration</span>
        </h1>
        
        <p className="text-lg md:text-xl text-zinc-300 max-w-2xl mx-auto mb-10 animate-fade-in-up opacity-0" style={{ animationDelay: '0.6s' }}>
          Over 10 years of delivering exclusive premium hookah experiences for your most memorable moments
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up opacity-0" style={{ animationDelay: '0.8s' }}>
          <Button onClick={scrollToBooking} className="btn-primary flex items-center gap-2" data-testid="hero-book-now">
            Book Your Event <ArrowRight size={20} />
          </Button>
          <Button 
            onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })} 
            className="btn-secondary"
            data-testid="hero-explore"
          >
            Explore Services
          </Button>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
          <ChevronDown size={32} className="text-[#D4AF37]" />
        </div>
      </div>
    </section>
  );
};

// Stats Section
const StatsSection = ({ stats }) => {
  return (
    <section className="bg-zinc-950 py-16 border-y border-zinc-800" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="stat-item hover-lift" data-testid="stat-years">
            <div className="stat-number">{stats.years_experience}+</div>
            <div className="stat-label">Years Experience</div>
          </div>
          <div className="stat-item hover-lift" data-testid="stat-events">
            <div className="stat-number">{stats.events_served}+</div>
            <div className="stat-label">Events Served</div>
          </div>
          <div className="stat-item hover-lift" data-testid="stat-clients">
            <div className="stat-number">{stats.happy_clients}+</div>
            <div className="stat-label">Happy Clients</div>
          </div>
          <div className="stat-item hover-lift" data-testid="stat-reviews">
            <div className="stat-number">{stats.five_star_reviews}+</div>
            <div className="stat-label">5-Star Reviews</div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Services Section
const ServicesSection = () => {
  return (
    <section id="services" className="section-padding bg-[#050505] relative grain" data-testid="services-section">
      <div className="section-container relative z-10">
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] uppercase tracking-widest text-sm mb-4 block">Our Services</span>
          <h2 className="section-title">Exclusive Catering For</h2>
          <p className="section-subtitle mx-auto mt-4">
            We bring the luxury hookah experience directly to your celebration, wherever you are
          </p>
          <div className="gold-divider"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((service, index) => (
            <div 
              key={service.id} 
              className="service-card animate-fade-in-up opacity-0" 
              style={{ animationDelay: `${0.1 * index}s` }}
              data-testid={`service-${service.id}`}
            >
              <div className="relative h-48 mb-6 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title} 
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="image-overlay"></div>
                <service.icon className="absolute bottom-4 left-4 text-[#D4AF37]" size={32} />
              </div>
              <h3 className="font-heading text-2xl text-white mb-3">{service.title}</h3>
              <p className="text-zinc-400">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Gallery Section
const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="gallery" className="section-padding bg-zinc-950" data-testid="gallery-section">
      <div className="section-container">
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] uppercase tracking-widest text-sm mb-4 block">Our Portfolio</span>
          <h2 className="section-title">Past Events Gallery</h2>
          <p className="section-subtitle mx-auto mt-4">
            A glimpse into the unforgettable experiences we've created
          </p>
          <div className="gold-divider"></div>
        </div>

        <div className="gallery-grid">
          {IMAGES.gallery.map((image, index) => (
            <Dialog key={index}>
              <DialogTrigger asChild>
                <div 
                  className={`gallery-item ${index === 0 || index === 7 ? 'md:col-span-2 md:row-span-2' : ''}`}
                  data-testid={`gallery-item-${index}`}
                >
                  <img src={image} alt={`Event ${index + 1}`} />
                </div>
              </DialogTrigger>
              <DialogContent className="bg-zinc-900 border-zinc-800 max-w-4xl" aria-describedby={`gallery-desc-${index}`}>
                <DialogHeader>
                  <DialogTitle className="sr-only">Event Photo {index + 1}</DialogTitle>
                </DialogHeader>
                <img src={image} alt={`Event ${index + 1}`} className="w-full h-auto" id={`gallery-desc-${index}`} />
              </DialogContent>
            </Dialog>
          ))}
        </div>
      </div>
    </section>
  );
};

// Gaslight Club Section
const GaslightSection = () => {
  const [currentImage, setCurrentImage] = useState(0);

  return (
    <section id="gaslight" className="section-padding bg-[#0a0a0a] relative" data-testid="gaslight-section">
      <div className="section-container">
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] uppercase tracking-widest text-sm mb-4 block">Featured Venue</span>
          <h2 className="section-title">Gaslight Bar & Restaurant</h2>
          <p className="section-subtitle mx-auto mt-4">
            Can't host at your location? Experience our 5-star luxury venue in the heart of Atlanta
          </p>
          <div className="gold-divider"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-zinc-400 mb-8">
              The Gaslight Club offers an exclusive atmosphere perfect for your celebration. 
              With premium amenities, professional staff, and a stunning ambiance, your event will be unforgettable.
            </p>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-center gap-4">
                <MapPin className="text-[#D4AF37]" size={24} />
                <span className="text-zinc-300">Heart of Atlanta, Georgia</span>
              </div>
              <div className="flex items-center gap-4">
                <Shield className="text-[#D4AF37]" size={24} />
                <span className="text-zinc-300">Professional Security On-Site</span>
              </div>
              <div className="flex items-center gap-4">
                <Users className="text-[#D4AF37]" size={24} />
                <span className="text-zinc-300">Wide Parking Lot Available</span>
              </div>
              <div className="flex items-center gap-4">
                <Award className="text-[#D4AF37]" size={24} />
                <span className="text-zinc-300">5-Star Luxury Experience</span>
              </div>
              <div className="flex items-center gap-4">
                <Wine className="text-[#D4AF37]" size={24} />
                <span className="text-zinc-300">Full Bar & Restaurant Service</span>
              </div>
            </div>

            <Button 
              onClick={() => document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' })}
              className="btn-primary"
              data-testid="gaslight-book-venue"
            >
              Book This Venue
            </Button>
          </div>

          <div className="space-y-4">
            {/* Main Image */}
            <div className="relative">
              <img 
                src={IMAGES.gaslightGallery[currentImage]} 
                alt="Gaslight Club venue" 
                className="w-full h-[400px] object-cover border border-zinc-800"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <span className="font-heading text-3xl text-white">Gaslight Club</span>
                <span className="block text-[#D4AF37] text-sm uppercase tracking-widest mt-2">Atlanta's Hidden Gem</span>
              </div>
            </div>
            
            {/* Thumbnail Gallery */}
            <div className="grid grid-cols-3 gap-2">
              {IMAGES.gaslightGallery.map((img, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentImage(index)}
                  className={`relative h-24 overflow-hidden border-2 transition-all ${currentImage === index ? 'border-[#D4AF37]' : 'border-zinc-800 hover:border-zinc-600'}`}
                >
                  <img src={img} alt={`Venue ${index + 1}`} className="w-full h-full object-cover" />
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Testimonials Section
const TestimonialsSection = ({ testimonials }) => {
  return (
    <section id="testimonials" className="section-padding bg-[#050505]" data-testid="testimonials-section">
      <div className="section-container">
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] uppercase tracking-widest text-sm mb-4 block">Client Stories</span>
          <h2 className="section-title">What Our Clients Say</h2>
          <div className="gold-divider"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id} 
              className="testimonial-card animate-fade-in-up opacity-0"
              style={{ animationDelay: `${0.1 * index}s` }}
              data-testid={`testimonial-${index}`}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star 
                    key={i} 
                    size={18} 
                    fill={i < testimonial.rating ? "#D4AF37" : "transparent"}
                    className={i < testimonial.rating ? "text-[#D4AF37]" : "text-zinc-700"}
                  />
                ))}
              </div>
              
              <p className="text-zinc-300 mb-6 italic">"{testimonial.text}"</p>
              
              <div className="border-t border-zinc-800 pt-4">
                <span className="font-heading text-white block">{testimonial.name}</span>
                <span className="text-[#D4AF37] text-sm">{testimonial.event_type}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Booking Section
const BookingSection = () => {
  const [date, setDate] = useState(undefined);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    event_type: '',
    guest_count: '',
    venue_type: '',
    location: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!date) {
      toast.error("Please select an event date");
      return;
    }

    if (!formData.name || !formData.email || !formData.phone || !formData.event_type || !formData.guest_count || !formData.venue_type) {
      toast.error("Please fill in all required fields");
      return;
    }

    setIsSubmitting(true);

    try {
      const bookingData = {
        ...formData,
        event_date: format(date, 'yyyy-MM-dd')
      };

      await axios.post(`${API}/bookings`, bookingData);
      toast.success("Booking request submitted! We'll contact you within 24 hours.");
      
      // Send WhatsApp notification
      sendWhatsAppNotification(bookingData);
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        event_type: '',
        guest_count: '',
        venue_type: '',
        location: '',
        message: ''
      });
      setDate(undefined);
    } catch (error) {
      toast.error("Failed to submit booking. Please try again.");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="booking" className="section-padding bg-zinc-950" data-testid="booking-section">
      <div className="section-container">
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] uppercase tracking-widest text-sm mb-4 block">Book Now</span>
          <h2 className="section-title">Request Your Quote</h2>
          <p className="section-subtitle mx-auto mt-4">
            Fill out the form below and we'll get back to you within 24 hours with a custom quote
          </p>
          <div className="gold-divider"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          <form onSubmit={handleSubmit} className="grid md:grid-cols-2 gap-8">
            {/* Left Column - Calendar */}
            <div className="space-y-6">
              <div>
                <Label className="form-label">Select Event Date *</Label>
                <div className="bg-zinc-900 border border-zinc-800 p-4 mt-2">
                  <CalendarComponent
                    mode="single"
                    selected={date}
                    onSelect={setDate}
                    disabled={(date) => date < new Date()}
                    className="text-white"
                    data-testid="booking-calendar"
                  />
                </div>
                {date && (
                  <p className="text-[#D4AF37] text-sm mt-2">
                    Selected: {format(date, 'MMMM d, yyyy')}
                  </p>
                )}
              </div>
            </div>

            {/* Right Column - Form Fields */}
            <div className="space-y-4">
              <div>
                <Label className="form-label">Full Name *</Label>
                <Input
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="Your full name"
                  className="form-input"
                  data-testid="booking-name"
                />
              </div>

              <div>
                <Label className="form-label">Email *</Label>
                <Input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="your@email.com"
                  className="form-input"
                  data-testid="booking-email"
                />
              </div>

              <div>
                <Label className="form-label">Phone *</Label>
                <Input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  placeholder="(123) 456-7890"
                  className="form-input"
                  data-testid="booking-phone"
                />
              </div>

              <div>
                <Label className="form-label">Event Type *</Label>
                <Select
                  value={formData.event_type}
                  onValueChange={(value) => setFormData({ ...formData, event_type: value })}
                >
                  <SelectTrigger className="form-input" data-testid="booking-event-type">
                    <SelectValue placeholder="Select event type" />
                  </SelectTrigger>
                  <SelectContent className="bg-zinc-900 border-zinc-800">
                    {SERVICES.map((service) => (
                      <SelectItem key={service.id} value={service.id} className="text-white hover:bg-zinc-800">
                        {service.title}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div>
                <Label className="form-label">Number of Guests *</Label>
                <Select
                  value={formData.guest_count}
                  onValueChange={(value) => setFormData({ ...formData, guest_count: value })}
                >
                  <SelectTrigger className="form-input" data-testid="booking-guests">
                    <SelectValue placeholder="Select guest count" />
                  </SelectTrigger>
                  <SelectContent className="bg-zinc-900 border-zinc-800">
                    <SelectItem value="1-10" className="text-white hover:bg-zinc-800">1-10 guests</SelectItem>
                    <SelectItem value="11-25" className="text-white hover:bg-zinc-800">11-25 guests</SelectItem>
                    <SelectItem value="26-50" className="text-white hover:bg-zinc-800">26-50 guests</SelectItem>
                    <SelectItem value="51-100" className="text-white hover:bg-zinc-800">51-100 guests</SelectItem>
                    <SelectItem value="100+" className="text-white hover:bg-zinc-800">100+ guests</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div>
                <Label className="form-label">Venue Type *</Label>
                <Select
                  value={formData.venue_type}
                  onValueChange={(value) => setFormData({ ...formData, venue_type: value })}
                >
                  <SelectTrigger className="form-input" data-testid="booking-venue-type">
                    <SelectValue placeholder="Select venue type" />
                  </SelectTrigger>
                  <SelectContent className="bg-zinc-900 border-zinc-800">
                    <SelectItem value="mobile" className="text-white hover:bg-zinc-800">Mobile Service (Your Location)</SelectItem>
                    <SelectItem value="gaslight_club" className="text-white hover:bg-zinc-800">Gaslight Club Venue</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {formData.venue_type === 'mobile' && (
                <div>
                  <Label className="form-label">Event Location</Label>
                  <Input
                    value={formData.location}
                    onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                    placeholder="Enter your event address"
                    className="form-input"
                    data-testid="booking-location"
                  />
                </div>
              )}

              <div>
                <Label className="form-label">Additional Details</Label>
                <Textarea
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  placeholder="Tell us more about your event..."
                  className="form-input min-h-[100px]"
                  data-testid="booking-message"
                />
              </div>

              <Button 
                type="submit" 
                className="btn-primary w-full flex items-center justify-center gap-2"
                disabled={isSubmitting}
                data-testid="booking-submit"
              >
                {isSubmitting ? (
                  <div className="spinner"></div>
                ) : (
                  <>
                    <Sparkles size={20} />
                    Request Quote
                  </>
                )}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

// Contact Section
const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      toast.error("Please fill in all required fields");
      return;
    }

    setIsSubmitting(true);

    try {
      await axios.post(`${API}/contact`, formData);
      toast.success("Message sent! We'll get back to you soon.");
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch (error) {
      toast.error("Failed to send message. Please try again.");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="section-padding bg-[#050505]" data-testid="contact-section">
      <div className="section-container">
        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div>
            <span className="text-[#D4AF37] uppercase tracking-widest text-sm mb-4 block">Get In Touch</span>
            <h2 className="section-title">Contact Us</h2>
            <p className="text-zinc-400 mt-6 mb-8">
              Have questions? We'd love to hear from you. Reach out to us using any of the methods below.
            </p>

            <div className="space-y-6">
              <a href="tel:678-697-7861" className="flex items-center gap-4 group" data-testid="contact-phone">
                <div className="w-12 h-12 bg-zinc-900 border border-zinc-800 flex items-center justify-center group-hover:border-[#D4AF37] transition-colors">
                  <Phone className="text-[#D4AF37]" size={20} />
                </div>
                <div>
                  <span className="text-zinc-500 text-sm block">Call Us</span>
                  <span className="text-white text-lg">678-697-7861</span>
                </div>
              </a>

              <a href="mailto:tgseyoum12@gmail.com" className="flex items-center gap-4 group" data-testid="contact-email">
                <div className="w-12 h-12 bg-zinc-900 border border-zinc-800 flex items-center justify-center group-hover:border-[#D4AF37] transition-colors">
                  <Mail className="text-[#D4AF37]" size={20} />
                </div>
                <div>
                  <span className="text-zinc-500 text-sm block">Email Us</span>
                  <span className="text-white text-lg">tgseyoum12@gmail.com</span>
                </div>
              </a>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-zinc-900 border border-zinc-800 flex items-center justify-center">
                  <MapPin className="text-[#D4AF37]" size={20} />
                </div>
                <div>
                  <span className="text-zinc-500 text-sm block">Location</span>
                  <span className="text-white text-lg">Atlanta, Georgia</span>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-zinc-900 border border-zinc-800 flex items-center justify-center">
                  <Clock className="text-[#D4AF37]" size={20} />
                </div>
                <div>
                  <span className="text-zinc-500 text-sm block">Response Time</span>
                  <span className="text-white text-lg">Within 24 Hours</span>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-zinc-900/50 backdrop-blur-sm border border-zinc-800 p-8">
            <h3 className="font-heading text-2xl text-white mb-6">Send a Message</h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label className="form-label">Name *</Label>
                <Input
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="Your name"
                  className="form-input"
                  data-testid="contact-form-name"
                />
              </div>

              <div>
                <Label className="form-label">Email *</Label>
                <Input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="your@email.com"
                  className="form-input"
                  data-testid="contact-form-email"
                />
              </div>

              <div>
                <Label className="form-label">Phone</Label>
                <Input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  placeholder="(123) 456-7890"
                  className="form-input"
                  data-testid="contact-form-phone"
                />
              </div>

              <div>
                <Label className="form-label">Subject *</Label>
                <Input
                  value={formData.subject}
                  onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                  placeholder="What's this about?"
                  className="form-input"
                  data-testid="contact-form-subject"
                />
              </div>

              <div>
                <Label className="form-label">Message *</Label>
                <Textarea
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  placeholder="Your message..."
                  className="form-input min-h-[120px]"
                  data-testid="contact-form-message"
                />
              </div>

              <Button 
                type="submit" 
                className="btn-primary w-full"
                disabled={isSubmitting}
                data-testid="contact-form-submit"
              >
                {isSubmitting ? <div className="spinner"></div> : 'Send Message'}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

// Floating WhatsApp Button
const WhatsAppButton = () => {
  const openWhatsApp = () => {
    const message = "Hi! I'm interested in booking EMBT Hookah Service for my event.";
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <button
      onClick={openWhatsApp}
      className="fixed bottom-6 left-6 z-50 bg-[#25D366] hover:bg-[#20BA5C] text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 flex items-center gap-2 group"
      data-testid="whatsapp-button"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={28} fill="white" />
      <span className="max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-300 whitespace-nowrap font-semibold">
        Chat with us
      </span>
    </button>
  );
};

// Footer
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" data-testid="footer">
      <div className="section-container">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img src={LOGO_URL} alt="EMBT Logo" className="w-16 h-16 rounded-full object-cover border-2 border-[#D4AF37]" />
              <div>
                <span className="font-heading text-2xl text-white block">EMBT</span>
                <span className="text-[#D4AF37] text-sm uppercase tracking-widest">Hookah Service</span>
              </div>
            </div>
            <p className="text-zinc-500 max-w-sm mb-6">
              Atlanta's premier mobile hookah catering service. Over 10 years of delivering exclusive premium experiences for your most memorable celebrations.
            </p>
            
            {/* Social Media Links */}
            <div className="flex items-center gap-4">
              <a 
                href="https://instagram.com/embthookahservice" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-zinc-900 border border-zinc-800 flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
                data-testid="social-instagram"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://facebook.com/embthookahservice" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-zinc-900 border border-zinc-800 flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
                data-testid="social-facebook"
              >
                <Facebook size={20} />
              </a>
              <a 
                href={`https://wa.me/${WHATSAPP_NUMBER}`}
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-zinc-900 border border-zinc-800 flex items-center justify-center hover:border-[#25D366] hover:text-[#25D366] transition-colors"
                data-testid="social-whatsapp"
              >
                <MessageCircle size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-white text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#services" className="footer-link">Services</a></li>
              <li><a href="#gallery" className="footer-link">Gallery</a></li>
              <li><a href="#gaslight" className="footer-link">Gaslight Club</a></li>
              <li><a href="#testimonials" className="footer-link">Reviews</a></li>
              <li><a href="#booking" className="footer-link">Book Now</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-white text-lg mb-4">Contact</h4>
            <ul className="space-y-2">
              <li><a href="tel:678-697-7861" className="footer-link flex items-center gap-2"><Phone size={16} /> 678-697-7861</a></li>
              <li><a href="mailto:tgseyoum12@gmail.com" className="footer-link flex items-center gap-2"><Mail size={16} /> tgseyoum12@gmail.com</a></li>
              <li><a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer" className="footer-link flex items-center gap-2"><MessageCircle size={16} /> WhatsApp</a></li>
              <li><span className="text-zinc-500 flex items-center gap-2"><MapPin size={16} /> Atlanta, Georgia</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-zinc-600 text-sm">
            &copy; {currentYear} EMBT Hookah Service. All rights reserved.
          </p>
          <p className="text-zinc-600 text-sm">
            Elevating celebrations since {currentYear - 10}
          </p>
        </div>
      </div>
    </footer>
  );
};

// Main Home Page
const Home = () => {
  const [scrolled, setScrolled] = useState(false);
  const [stats, setStats] = useState({
    years_experience: 10,
    events_served: 500,
    happy_clients: 450,
    five_star_reviews: 200
  });
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [statsRes, testimonialsRes] = await Promise.all([
          axios.get(`${API}/stats`),
          axios.get(`${API}/testimonials`)
        ]);
        setStats(statsRes.data);
        setTestimonials(testimonialsRes.data);
      } catch (error) {
        console.error('Failed to fetch data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="home-page">
      <Navbar scrolled={scrolled} />
      <HeroSection />
      <StatsSection stats={stats} />
      <ServicesSection />
      <GallerySection />
      <GaslightSection />
      <TestimonialsSection testimonials={testimonials} />
      <BookingSection />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: '#1A1A1A',
            color: '#fff',
            border: '1px solid #27272a'
          }
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
